import Scrollbars from './Scrollbars'

export default Scrollbars
